module.exports = __webpack_public_path__ + "img/contentImgHover2.28fde9e.webp";